import React from "react";
import Form from "./Form";

const Edit = () => <Form edit />;

export default Edit;



// WEBPACK FOOTER //
// ./src/offers/Edit.js